exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Slider {\n  display: flex;\n  align-items: center; }\n  .Slider input {\n    width: 50%;\n    margin-right: 10px; }\n    .Slider input[type=\"number\"] {\n      width: 25%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/style/Slider.scss
// module id = 1710
// module chunks = 0